import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPriceListSubGroup implements BaseEnumType {
  private static allValues: EnumPriceListSubGroup[] = []; // make sure this is top-most
  
  public static packageType = new EnumPriceListSubGroup(0, "PackageType", "enum_price_list_sub_group_package_type");
  public static pricingCategory = new EnumPriceListSubGroup(1, "PricingCategory", "enum_price_list_sub_group_pricing_category");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPriceListSubGroup.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isPackageType() { return this === EnumPriceListSubGroup.packageType; }
  public isPricingCategory() { return this === EnumPriceListSubGroup.pricingCategory; }

  public static getValues(): readonly EnumPriceListSubGroup[] {
    return EnumPriceListSubGroup.allValues;
  }

  public static getValuesExcept0(): readonly EnumPriceListSubGroup[] {
    return EnumPriceListSubGroup.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPriceListSubGroup {
    const found = EnumPriceListSubGroup.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPriceListSubGroup - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPriceListSubGroup): EnumPriceListSubGroup {
    const found = name ? EnumPriceListSubGroup.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPriceListSubGroup - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPriceListSubGroup>): boolean {
    return this.key === other?.key;
  }
}